(ns ncr.nsql.context
  (:require
   #?(:clj [taoensso.encore :refer [have have! have?]]
      :cljs [taoensso.encore :refer-macros [have have! have?]])
   [globus.core :as glob]
   [clojure.string :as str]))

(def ^:private default-env
  {:null [:immediate :null nil]
   :true [:immediate :boolean true]
   :false [:immediate :boolean false]

   :owner [:column :user :reference/owner]
   :creator [:column :user :reference/creator]
   :folder [:column :folder :reference/folder]
   :labels [:column :labels :reference/labels]
   :attachments [:column :attachments :reference/cache_attachments_json]
   :header [:column :text :reference/fulltext]
   :body [:column :text :reference/extracted]
   :text [:column :either-texts [:reference/fulltext :reference/extracted]]
   :created [:column :timestamp :reference/created]
   :updated [:column :timestamp :reference/updated]
   :revoked [:column :timestamp :reference/revoked]

   :datev [:column :virtual :props-datev/start-date]
   :datev/date
   [:column :date/interval [:props-datev/start-date :props-datev/end-date]]

   :common/value [:column :either/decimal [:common/netto :common/brutto]]

   ; :common/date [:column :date :props_common/date]
   })

(def ^:private PDEFS-TYPES
  {:money :decimal
   :boolean :boolean
   :date :date})

(defmulti pdef->env (fn [prop-group [pname pdef :as prop]] (:type pdef)))

(defmethod pdef->env :default [_ _] nil)

(defmethod pdef->env :money [{:keys [prefix table properties]} [pname pdef]]
  {(keyword (name prefix) (name pname))
   [:column :decimal
    (keyword (name table) (name (:column pdef)))]})

(defmethod pdef->env :date [{:keys [prefix table properties]} [pname pdef]]
  {(keyword (name prefix) (name pname))
   [:column :date
    (keyword (name table) (name (:column pdef)))]})

(defmethod pdef->env :boolean [{:keys [prefix table properties]} [pname pdef]]
  {(keyword (name prefix) (name pname))
   [:column :boolean
    (keyword (name table) (name (:column pdef)))]})

(defn pdefs->env [pdefs]
  (apply merge
    (for [{:keys [properties] :as prop-group} pdefs
          prop properties]
      (pdef->env prop-group prop))))

(defn- strip-ns [mp]
  (into {} (map (juxt (comp keyword name key) val) mp)))

(defn- make-index [items]
  (->> items
    (map #(let [{:keys [id name]} (strip-ns %)] [(str/lower-case name) id]))
    (into {})))

(def ^:dynamic *context*
  {:locale :en
   :enums {}
   :env default-env})

(defn amend-context
  ([opts] (amend-context *context* opts))
  ([ctx opts]
   {:locale (or (:locale opts) (:locale ctx))
    :env (merge (:env ctx) (:env opts))
    :enums (into (:enums ctx)
             (map (juxt key (comp make-index val)) (:enums opts)))}))

(defmacro with-context [opts & body]
  `(binding [*context* (amend-context ~opts)]
     ~@body))

(defn lookup-ident [kw]
  (let [{:keys [env]} *context*]
    (or (env kw)
      (when-not (namespace kw) (env (keyword "common" (name kw)))))))

(defn lookup-enum [dtype nm]
  (let [idx (have! (get-in *context* [:enums dtype]))]
    (idx (str/lower-case nm))))

(defn glob-enum [dtype glob]
  (let [idx (have! (get-in *context* [:enums dtype]))
        ks (glob/glob glob (keys idx) {:ignorecase true})]
    (map idx ks)))

(comment
  (lookup-ident :null)
  (lookup-ident :text)
  (lookup-ident :common/missing))
